module.exports = __webpack_public_path__ + "media/images/bi-chevron-up-4a11dbbc.svg";